"use client";
import { cn } from "@/lib/utils";

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "default" | "elevated" | "outlined" | "interactive";
  padding?: "none" | "sm" | "md" | "lg";
}

export function Card({ className = "", variant = "default", padding = "md", ...props }: CardProps) {
  const paddingClasses: Record<string, string> = { none: "p-0", sm: "p-4", md: "p-5", lg: "p-7" };
  return (
    <div
      className={cn(
        "card rounded-xl border shadow-xs",
        variant === "default" && "border-[var(--color-border)] bg-[var(--color-surface)]",
        variant === "elevated" && "border-[var(--color-border)] bg-[var(--color-surface)] shadow-md",
        variant === "outlined" && "border-2 border-[var(--color-border-strong)] bg-[var(--color-surface)]",
        variant === "interactive" && "card-interactive shadow-xs hover:shadow-sm",
        paddingClasses[padding],
        className
      )}
      {...props}
    />
  );
}
